<template>
  <div class="sharing-decorator">
    <div class="sharing-main">
      <div class="left">
        <div class="video-image">
          <el-image style="width: 100%; height: 100%" :src="details.coverUrl || ''" fit="contain">
            <template #error>
              <el-image style="width: 100%; height: 100%" :src="require('@/assets/images/12-数据为空.png')" fit="contain" />
            </template>
          </el-image>
          <div class="video-image-mask">
            <div>{{ details.name }}</div>
          </div>
        </div>
        <div class="button-container">
          <el-button type="primary" class="share-button" @click="copyTextGo">获取视频分享链接</el-button>
        </div>
      </div>
      <div class="right">
        <div class="qr-image">
          <vue-qrcode style="width: 100%;" v-if=details.videoMakeMediaUrl
            :value="details.videoMakeMediaUrl"></vue-qrcode>
        </div>
        <div class="qr-description">手机扫码预览/分享</div>
      </div>
    </div>
    <div class="sharing-bottom" v-if="false">
      <!-- 这里可以放一些底部内容 -->
    </div>
  </div>
</template>

<script setup>
import { copyText } from '@/utils/index'
const url = '';

let props = defineProps({
  details: {
    type: Object,
    default: () => ({}),
  }
})

let copyTextGo = () => {
  let { videoMakeMediaUrl, name } = props.details
  let text = `【${name}】${videoMakeMediaUrl}`
  copyText(text)
}
</script>

<style lang="scss" scoped>
.sharing-decorator {
  background-color: #1d1e1f71;
  padding: 10px;
  border-radius: 12px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
}

.sharing-main {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.left,
.right {
  background-color: #ffffff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.left {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.right {
  width: 35%;

}

.video-image {
  position: relative;
  max-height: 150px;
  // background-color: #000000;
  /* Set a fixed height for image container */
}

.video-image-mask {
  width: 100%;
  position: absolute;
  bottom: 0;
  background-color: #1d1c1c83;
  padding: 5px;
  box-sizing: border-box;
  font-size: 12px
}

.button-container {
  text-align: right;
  margin-top: 10px;
}

.share-button {
  background-color: #007bff;
  border-color: #007bff;
  color: #ffffff;
}

.share-button:hover {
  background-color: #0056b3;
  border-color: #004494;
}

.qr-image {
  margin-bottom: 10px;
  text-align: center;
}

.qr-description {
  font-size: 14px;
  color: #cccccc;
  text-align: center;
}

.sharing-bottom {
  margin-top: 20px;
}
</style>
